
export default [
    {
        comment: '',
        error_id: 'FW 01',
        data: [
            {cross_section: '43827', femafw_prof_delta_ws: 1.44},
            {cross_section: '43002', femafw_prof_delta_ws: -0.41},
        ]
    },
    {
        comment: '',
        error_id: 'FW 01 IB',
        data: [
            {cross_section: '43827', femafw_prof_delta_ws: 1.44},
            {cross_section: '43002', femafw_prof_delta_ws: -0.41},
        ]
    },
]